import { ACTIVE_FAVORITES_BY_MODULE, SEARCH_HISTORY_BY_MODULE } from 'src/stores/searchHistory/localStorageKeys';
import { ActiveFavoritesByModule, SearchHistoryByModule } from 'src/stores/searchHistory/types';

import { instanceSpecificLocalStorageKey } from 'src/util/common';

export interface SearchHistoryStateInterface {
	activeFavoritesByModule: ActiveFavoritesByModule;
	backendSyncStatus: 'error' | 'idle' | 'loading' | 'success';
	historyByModule: SearchHistoryByModule;
	lastBackendSync: null | number;
}

function state(): SearchHistoryStateInterface {
	const loadHistoryFromStorage = (): SearchHistoryByModule => {
		try {
			const stored = localStorage.getItem(instanceSpecificLocalStorageKey(SEARCH_HISTORY_BY_MODULE));
			if (stored) {
				const parsed = JSON.parse(stored) as SearchHistoryByModule;
				if (typeof parsed === 'object' && parsed !== null) {
					return parsed;
				}
			}
		} catch (error) {
			console.warn('Failed to load search history from localStorage:', error);
		}
		return {};
	};

	const loadActiveFavoritesFromStorage = (): ActiveFavoritesByModule => {
		try {
			const stored = localStorage.getItem(instanceSpecificLocalStorageKey(ACTIVE_FAVORITES_BY_MODULE));
			if (stored) {
				const parsed = JSON.parse(stored) as ActiveFavoritesByModule;
				if (typeof parsed === 'object' && parsed !== null) {
					return parsed;
				}
			}
		} catch (error) {
			console.warn('Failed to load search history from localStorage:', error);
		}
		return {};
	};

	return {
		activeFavoritesByModule: loadActiveFavoritesFromStorage(),
		backendSyncStatus: 'idle',
		historyByModule: loadHistoryFromStorage(),
		lastBackendSync: null,
	};
}

export default state;
